<template>
    <div>
        <el-container style="height: 70vh">
            <el-aside width="300px" style="border-right: 1px solid #eee; padding: 10px">
                <!-- <p>上传参考</p> -->
                <div class="name_box">
                    <i class="el-icon-plus" @click="addAuthorEvt"></i>
                    <el-input class="nameSearch" ref="nameInput" v-if="!nameId" @focus="searchInpEvt" @input="searchNameEvt"
                        @keyup.enter.native="handleEnter" v-model="input" placeholder="选择作者..."></el-input>
                    <el-tag v-else v-for="tag in tags" :key="tag.name" @close="closeTagEvt" closable :type="tag.type">
                        {{ tag.name }}
                    </el-tag>
                </div>
                <!-- 选择作者开始 -->
                <div v-if="nameList.length !== 0" class="result_box">
                    <div class="Selected" @click="selectedNameEvt(item)" v-for="(item, index) in nameList" :key="item.id">
                        <div>
                            <b></b>
                            <i v-if="item.id == nameId"></i>
                        </div>
                        <span>{{ item.username }}</span>
                    </div>
                </div>
                <!-- 选择作者结束 -->

                <!-- 新建作者开始 -->
                <div class="addAuthor" v-if="addAuthor">
                    <p>新建作者</p>
                    <div class="author_box">
                        <el-input ref="authorInput" v-model="AuthorNameInp" style="width: 120px"
                            placeholder="输入作者..."></el-input>
                        <el-input v-model="categoryInput" @focus="categoryEvt" style="width: 120px"
                            placeholder="筛选类别"></el-input>
                    </div>
                    <div class="screen_box" v-if="category">
                        <div class="category" v-for="item in categoryList" :key="item.id" @click="selectCatEvt(item)">
                            <div>
                                <b></b>
                                <i v-if="item.id == categoryId"></i>
                            </div>
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                    <div class="btn_box">
                        <el-button size="mini" @click="saveAuthorEvt" type="primary">保存</el-button>
                        <el-button size="mini" @click="cancellationEvt">取消</el-button>
                    </div>
                </div>
                <!-- 新建作者结束 -->
            </el-aside>

            <el-container>
                <el-main>
                    <div class="upload_btn">
                        <el-button size="mini" @click="submitEvt" type="primary">完成</el-button>
                    </div>

                    <el-upload class="upload_box" action="#" list-type="picture-card" drag multiple :auto-upload="false"
                        :on-change="uploadEvt">
                        <i class="el-icon-plus"></i>
                    </el-upload>

                    <div v-for="(item, index) in uploadImgList" :key="index" class="img_box">
                        <img :src="item.url" alt="" />
                        <div v-if="item.repeat" class="repeat_box">
                            <span>该照片重复</span>
                        </div>
                        <el-progress v-if="percentageShow && item.uid == regularNum" class="percentage_box"
                            :percentage="percentage"></el-progress>
                        <div class="complete_box" v-if="item.complete">
                            <span>上传完成</span>
                        </div>
                        <div class="close_box" @click="closeImgEvt(item)">
                            <i class="el-icon-close"></i>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import SparkMD5 from "spark-md5";
import {
    getAuthorApi,
    addAuthorApi,
    getUploadSignatureApi,
    startUploadApi,
    completeUploadApi,
    repeatImgApi,
} from "../apis/uploadApi";
export default {
    data() {
        return {
            input: "",
            tags: [
                {
                    name: "标签一",
                    type: "",
                },
            ],

            nameList: [],
            nameId: "",
            addAuthor: false,
            category: false,
            categoryList: [
                {
                    id: 1,
                    name: "艺术家",
                },
                {
                    id: 2,
                    name: "设计公司",
                },
            ],
            categoryId: "",
            categoryInput: "",
            AuthorNameInp: "",
            //上传列表
            dataList: [],
            uploadImgList: [],
            dialogVisible: false,
            timer: null,
            regular: null,
            regularNum: null,
            percentage: 30,
            percentageShow: false,
        };
    },
    methods: {
        //获取作者数据（输入框获取焦点）
        searchInpEvt() {
            getAuthorApi().then((res) => {
                if (res.code == 1000) {
                    this.nameList = res.data.author;
                }
            });
        },
        handleEnter() {
            if (this.nameList.length == 0) {
                this.addAuthor = true;
                this.AuthorNameInp = this.input;
                this.$nextTick(() => {
                    this.$refs.nameInput.blur();
                    this.$refs.authorInput.focus();
                });
            }
        },
        //选中名字
        selectedNameEvt(res) {
            this.tags = [];
            this.nameId = res.id;
            this.tags = [
                {
                    name: res.username,
                },
            ];
            this.nameList = [];
        },
        //关闭名字标签
        closeTagEvt() {
            this.tags = [];
            this.nameId = "";
        },
        //搜索名字
        searchNameEvt(e) {
            let arr = [];
            if (e.length == 0) {
                this.searchInpEvt();
            }
            this.clearTimer();
            this.timer = setTimeout(() => {
                this.nameList.filter((res) => {
                    if (res.username.toLowerCase().indexOf(e.toLowerCase()) == 0) {
                        arr.push(res);
                    }
                    if (res.username.toLowerCase().indexOf(e.toLowerCase()) == 1) {
                        setTimeout(() => { }, 50);
                    }
                    if (res.username.toLowerCase().indexOf(e.toLowerCase()) > 1) {
                        setTimeout(() => {
                            arr.push(res);
                        }, 150);
                    }
                });
                this.nameList = arr;
            }, 400);
        },
        //清除定时器
        clearTimer() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        },
        //添加作者
        addAuthorEvt() {
            this.addAuthor = !this.addAuthor;
        },
        //选择类型
        categoryEvt() {
            this.category = true;
        },
        //选择类型
        selectCatEvt(res) {
            this.categoryId = res.id;
            this.categoryInput = res.name;
            this.category = false;
        },

        //取消添加作者
        cancellationEvt() {
            this.addAuthor = false;
        },
        //确定保存添加作者
        saveAuthorEvt() {
            if (this.AuthorNameInp == "" || this.categoryId == "") {
                this.$message({
                    message: "请输入名字或者选择类型！",
                    type: "warning",
                });
                return;
            }
            addAuthorApi({
                name: this.AuthorNameInp,
                type: this.categoryId,
            }).then((res) => {
                if (res.code == 1000) {
                    this.addAuthor = false;
                    this.category = false;
                    this.input = "";
                    this.nameId = res.id;
                    this.tags = [
                        {
                            name: res.name,
                        },
                    ];
                }
            });
        },
        //上传
        uploadEvt(file, fileList) {
            if (this.nameId == "") {
                this.$message({
                    message: "请选择作者后，然后上传！",
                    type: "warning",
                });
                return;
            }

            let imgErr = (file, msg) => {
                let index = fileList.findIndex((fileItem) => {
                    return fileItem.uid === file.uid;
                });
                fileList.splice(index, 1);
                this.$message({
                    message: msg,
                    type: "warning",
                });
                return false;
            };
            if (file.raw.type !== "image/jpg" && file.raw.type !== "image/jpeg") {
                return imgErr(file, "只支持jpg格式图片");
            }
            if (file.size / 1024 / 1024 > 50) {
                return imgErr(file, "图片大小不能超过 50MB!");
            }

            const fileReader = new FileReader();

            fileReader.readAsBinaryString(file.raw);

            fileReader.onload = (e) => {
                const md5 = SparkMD5.hashBinary(e.target.result);
                file.hash = md5;
                repeatImgApi({
                    md5,
                }).then((res) => {
                    if (res.code == 1000) {
                        file.percentage = true;
                        this.dataList.push(file);
                    }
                    if (res.code == 1004) {
                        file.repeat = true;
                    }
                    this.percentageShow = true;
                    this.uploadImgList.push(file);
                });
            };
        },
        //获取文件上传签名
        getReadyId(file) {
            getUploadSignatureApi({
                md5: file.hash,
            }).then((res) => {
                if (res.code == 1004) {
                    this.$message({
                        message: "该图片重复",
                        type: "warning",
                    });
                    return;
                }
                if (res.code == 1000) {
                    this.startUpload(file, res);
                }
            });
        },
        //确定提交上传
        submitEvt() {
            if (this.nameId == "") {
                this.$message({
                    message: "请选择作者后在上传",
                    type: "warning",
                });
                return;
            }
            if (this.dataList.length == 0) {
                this.$message({
                    message: "请选择文件后上传",
                    type: "warning",
                });
                return;
            }
            this.regular = setInterval(() => {
                if (this.dataList.length == 0) {
                    // uploadTs.value = true
                    return;
                }
                this.getReadyId(this.dataList.pop());
            }, 1000);
            this.percentageShow = true;
        },

        //code1000
        startUpload(file, data) {
            this.percentageShow = true;
            let url = `https://${data.host}`;
            let formData = new FormData();
            let imgType = "";
            switch (file.raw.type) {
                case "image/png":
                    imgType = ".png";
                    break;
                case "image/jpeg":
                    imgType = ".jpeg";
                    break;
                case "image/jpg":
                    imgType = ".jpg";
            }
            formData.append("key", file.hash + imgType);
            formData.append("policy", data.policy);
            formData.append("OSSAccessKeyId", data.accessid);
            formData.append("success_action_status", "200");
            formData.append("signature", data.signature);
            formData.append("file", file.raw);
            this.regularNum = file.uid;
            startUploadApi(url, formData).then((res) => {
                setInterval(() => {
                    if (this.percentage >= 100) {
                        return;
                    }
                    this.percentage += 2;
                }, 20);
                completeUploadApi({
                    md5: file.hash,
                    name: file.hash + imgType,
                    id: this.nameId,
                }).then((val) => {
                    this.uploadImgList = this.uploadImgList.map((v) => {
                        if (v.uid == file.uid) {
                            v.complete = true;
                        }
                        return v;
                    });
                    this.percentageShow = false;
                    this.percentage = 30;
                });
            });
        },
        //删除上传列表
        closeImgEvt(data) {
            if (data.percentage) {
                this.dataList.map((v, index) => {
                    if (v.uid == data.uid) {
                        this.dataList.splice(index, 1);
                    }
                });
            }
            this.uploadImgList.map((res, index) => {
                if (data.uid == res.uid) {
                    this.uploadImgList.splice(index, 1);
                }
            });
        },
    },
};
</script>

<style scoped>
.name_box {
    width: 100%;
    background-color: rgba(103, 195, 249, 0.2);
    border-radius: 7px;
    height: 35px;
    padding: 3px;
    padding-left: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.name_box span {
    height: 27px;
    line-height: 27px;
    padding-left: 10px;
    color: #fff;
    background-color: rgb(43, 147, 233);
    font-size: 12px;
}

.nameSearch {
    position: absolute;
    margin-left: 15px;
    width: 230px;
}

>>>.nameSearch input {
    height: 29px;
    border: none;
    background: none;
    font-size: 12px;
}

>>>.el-tag .el-icon-close {
    color: #fff;
}

.name_box .el-icon-plus {
    background-color: #848282;
    font-size: 15px;
    border-radius: 50%;
    margin-right: 15px;
    color: #fff;
}

.result_box {
    margin-top: 8px;
    width: 100%;
    max-height: 400px;
    min-height: 400px;
    overflow-x: hidden;
    border-radius: 5px;
    padding: 3px;
    box-shadow: 0px 0px 4px 0px #d6d5d5;
}

.Selected {
    padding-left: 20px;
    height: 20px;
    font-size: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;
}

.Selected:hover {
    background-color: rgba(103, 195, 249, 0.2);
    border-radius: 3px;
}

.Selected div {
    position: relative;
}

.Selected b {
    display: block;
    width: 12px;
    height: 12px;
    border: 1px solid #369cdc;
    border-radius: 50%;
    margin-top: 2px;
}

.Selected i {
    display: block;
    width: 8px;
    height: 8px;
    background-color: #369cdc;
    border-radius: 50%;
    position: absolute;
    top: 4px;
    left: 2px;
}

.Selected span {
    padding-left: 20px;
}

.addAuthor {
    margin-top: 10px;
    height: 300px;
    border-radius: 5px;
    padding: 3px;
    position: relative;
    font-size: 12px;
    box-shadow: 0px 0px 4px 0px #d6d5d5;
}

.addAuthor p {
    font-size: 15px;
}

.author_box {
    display: flex;
    justify-content: space-around;
}

.screen_box {
    position: absolute;
    top: 100px;
    right: 10px;
    width: 120px;
    height: 60px;
    padding: 3px;
    box-shadow: 0px 0px 4px 0px #d6d5d5;
}

.category {
    position: relative;
    display: flex;
    margin: 5px;
    cursor: pointer;
}

.category:hover {
    background-color: rgba(103, 195, 249, 0.2);
    border-radius: 3px;
}

.category span {
    padding-left: 15px;
}

.screen_box b {
    display: block;
    width: 12px;
    height: 12px;
    border: 1px solid #369cdc;
    border-radius: 50%;
    margin-top: 2px;
}

.screen_box i {
    display: block;
    width: 8px;
    height: 8px;
    background-color: #369cdc;
    border-radius: 50%;
    position: absolute;
    top: 4px;
    left: 2px;
}

.upload_box {
    float: left;
    width: 245px;
}

.img_box {
    width: 240px;
    height: 160px;
    float: left;
    margin-right: 5px;
    position: relative;
    margin-bottom: 5px;
}

.img_box img {
    width: 100%;
    height: 100%;
}

.repeat_box {
    position: absolute;
    width: 100%;
    background: url("../img/cha.png") no-repeat 8px center / 12px 12px;
    background-color: rgb(108, 108, 108, 0.5);
    bottom: 1px;
    color: #f00;
    font-weight: 600;
}

.complete_box {
    position: absolute;
    background-color: rgb(108, 108, 108, 0.8);
    width: 100%;
    bottom: 1px;
    color: #fff;
}

.complete_box span {
    padding-left: 20px;
}

.repeat_box span {
    padding-left: 20px;
}

.close_box {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 19px;
    color: #fff;
    cursor: pointer;
}

.percentage_box {
    position: absolute;
    width: 100%;
    bottom: 1px;
}

>>>.el-progress__text {
    color: #fff !important;
}

.btn_box {
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.upload_btn {
    position: absolute;
    top: 50px;
    right: 50px;
}

>>>.el-upload-dragger {
    width: 240px;
    height: 160px;
}

>>>.el-upload-list--picture-card {
    display: none;
}

>>>.el-upload--picture-card {
    border: none;
}

.el-header {
    background-color: #b3c0d1;
    color: #333;
    line-height: 60px;
}

.el-aside {
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/upload/index.vue